import * as React from 'react';

import { TextInput } from '@coursera/coursera-ui';

import _t from 'i18n!nls/user-account';

type Props = {
  value: string;
  style?: any;
  inputStyle?: any;
  autoFocus?: boolean;
  onChange: (x0: React.SyntheticEvent<any>) => void;
};

// TODO(Audrey): change name from code to verificationCode once we finish refactoring
export default function VerificationField({ value, style, inputStyle, ...rest }: Props) {
  const _T = {
    VERIFICATION_CODE: _t('Verification Code'),
    VERIFICATION_CODE_REQ_VALIDATION: _t('Please enter a password'),
  };

  return (
    <TextInput
      name="code"
      componentId="verificationCodeInput"
      label={_T.VERIFICATION_CODE}
      placeholder={_T.VERIFICATION_CODE}
      value={value}
      style={style}
      nativeHtmlAttributes={{
        id: 'user-modal-2fa',
        required: true,
        'data-e2e': 'verification-code-field',
        onInvalid: (event) => {
          const target = event.target as HTMLInputElement;
          const { value: inputText } = target;
          if (!inputText) {
            target.setCustomValidity(_T.VERIFICATION_CODE_REQ_VALIDATION);
          }
        },
        onInput: (event) => (event.target as HTMLInputElement).setCustomValidity(''),
        style: inputStyle,
        ...rest,
      }}
    />
  );
}
